import styled from 'styled-components';
import { SectionBase } from '../../styles';

// Override SectionBase to remove top padding so sticky pills sit flush at the top
export const ScrollContainer = styled(SectionBase)`
	padding-top: 0;
`;

export const HeaderArea = styled.div`
	padding-top: 42px;
`;

export const CategorySection = styled.section`
	margin-bottom: 40px;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const CategoryHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
`;

export const CategoryTitle = styled.h3`
	font-size: 28px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	margin: 0;
	margin-top: 24px;
	margin-bottom: 8px;
`;

export const CategoryControls = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;
`;

export const TogglePill = styled.button<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 4px 12px 4px 8px;
	border-radius: 6px;
	border: 1px solid ${({ theme, $active }) => ($active ? theme.blue[600] : theme.gray[400])};
	background-color: ${({ theme, $active }) => ($active ? theme.blue[500] : 'transparent')};
	color: ${({ theme, $active }) => ($active ? theme.gray[1000] : theme.gray[700])};
	font: inherit;
	font-size: 12px;
	font-weight: 500;
	transition: all 0.15s ease;

	&:hover {
		border-color: ${({ theme }) => theme.blue[600]};
		background-color: ${({ theme, $active }) => ($active ? theme.blue[400] : theme.blue[300])};
	}

	svg {
		flex-shrink: 0;
	}
`;

// Wrapper for each category section in list mode; provides inter-section spacing
export const ListSection = styled.div`
	margin-top: 36px;

	&:first-child {
		margin-top: 4px;
	}
`;

// List view section divider
export const ListSectionHeader = styled.div`
	font-size: 24px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[900]};
	padding: 0 8px 6px;
`;
